import { render, staticRenderFns } from "./upStorageEntryLabel.vue?vue&type=template&id=18b9b311&scoped=true&"
import script from "./upStorageEntryLabel.vue?vue&type=script&lang=js&"
export * from "./upStorageEntryLabel.vue?vue&type=script&lang=js&"
import style0 from "./upStorageEntryLabel.vue?vue&type=style&index=0&id=18b9b311&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b9b311",
  null
  
)

export default component.exports